var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcowarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8284 9.6655L77.4069 57.4332C78.4183 59.1849 78.9999 61.2158 78.9999 63.3838C78.9999 69.9676 73.6625 75.3054 67.0783 75.3054H39.4999L29.9626 39.5L39.4999 3.69482C43.9159 3.69482 47.7682 6.09769 49.8284 9.6655Z",
    fill: "#3B4145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1715 9.6655L1.59281 57.4332C0.581545 59.1849 0 61.2158 0 63.3838C0 69.9676 5.33744 75.3054 11.9216 75.3054H39.5V3.69482C35.084 3.69482 31.2317 6.09769 29.1715 9.6655Z",
    fill: "#525A61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2776 59.8174L45.6992 12.0502C44.4562 9.89635 42.1737 8.5373 39.7051 8.46741L63.2923 70.5372H67.0786C71.0222 70.5372 74.2315 67.3281 74.2315 63.3843C74.2315 62.1317 73.9008 60.8983 73.2776 59.8174Z",
    fill: "#FFB751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6393 59.8174C69.1781 60.8983 69.4626 62.1317 69.4626 63.3843C69.4626 67.328 66.6953 70.5372 63.292 70.5372H11.9215C7.97778 70.5372 4.76855 67.328 4.76855 63.3843C4.76855 62.1317 5.09921 60.8983 5.72226 59.8174L33.3007 12.0502C34.5787 9.83759 36.9535 8.46265 39.4999 8.46265C39.5682 8.46265 39.6366 8.46419 39.7049 8.46743C41.8237 8.55013 43.7805 9.90594 44.847 12.0502L68.6393 59.8174Z",
    fill: "#FFD764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 54.6412V62.5889C41.6952 62.5889 43.4739 60.8102 43.4739 58.615C43.4739 56.42 41.6952 54.6412 39.5 54.6412Z",
    fill: "#3B4145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 54.6412C39.9387 54.6412 40.2948 56.42 40.2948 58.6152C40.2948 60.8103 39.9387 62.5891 39.5 62.5891C37.3049 62.5891 35.5261 60.8103 35.5261 58.6152C35.5261 56.42 37.3049 54.6412 39.5 54.6412Z",
    fill: "#525A61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 20.4669V49.8734C41.6952 49.8734 43.4739 48.0932 43.4739 45.8995V24.4408C43.4739 22.2457 41.6952 20.4669 39.5 20.4669Z",
    fill: "#3B4145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 20.4669C39.9387 20.4669 40.2948 22.2457 40.2948 24.4408V45.8995C40.2948 48.093 39.9387 49.8734 39.5 49.8734C37.3049 49.8734 35.5261 48.0932 35.5261 45.8995V24.4408C35.5261 22.2457 37.3049 20.4669 39.5 20.4669Z",
    fill: "#525A61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcowarning);
export default __webpack_public_path__ + "static/media/ico.warning.0441b1d6f9f7a82fd981349936f208d8.svg";
export { ForwardRef as ReactComponent };